
    import * as React from 'react';

    const Shipping16 = ({ color = 'currentcolor', height = '16px', width = '16px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 16 16" style={svgStyle}><path d="M5.2 11.571c0 .79-.627 1.429-1.4 1.429-.773 0-1.4-.64-1.4-1.429H1V3h9.1v1.429h3.119L15 7.935v3.636h-1.4c0 .79-.627 1.429-1.4 1.429-.773 0-1.4-.64-1.4-1.429H5.2zm-.187-.714H9.4V3.714H1.7v7.143h.887a1.395 1.395 0 011.213-.714c.518 0 .97.287 1.213.714zM10.1 5.143v5.714h.887a1.395 1.395 0 011.213-.714c.518 0 .97.287 1.213.714h.887V8.714h-2.8V5.857h1.656l-.363-.714H10.1zm2.1 1.428V8h2.034l-.724-1.429H12.2zm0 5.715c.387 0 .7-.32.7-.715a.707.707 0 00-.7-.714c-.387 0-.7.32-.7.714 0 .395.313.715.7.715zm-8.4 0c.387 0 .7-.32.7-.715a.707.707 0 00-.7-.714c-.387 0-.7.32-.7.714 0 .395.313.715.7.715z" /></svg>
        </div>
      );
    };

    Shipping16.displayName = 'Shipping16';

    export default Shipping16;
  